import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { obtenerDetalleSecadaDosMas } from '../../actions/listados'
import TablaDetalleSecadaDosMasView from '../../components/listados/TablaDetalleSecadaDosMasView'

function DetalleMercaderiaSecadaDosMas (props) {
  const { detalle, obtenerDetalleSecadaDosMas } = props

  useEffect(() => {
    console.log(detalle)
    obtenerDetalleSecadaDosMas(detalle.fechaDeDescarga, detalle.razonSocialExportador, detalle.cereal)
  }, [obtenerDetalleSecadaDosMas, detalle])

  return (
    <TablaDetalleSecadaDosMasView />
  )
}

const mapActionsToProps = {
  obtenerDetalleSecadaDosMas
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(DetalleMercaderiaSecadaDosMas)
